import { Component, OnInit } from '@angular/core';
import { CommunicationsService } from '@app/_services';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MessageInformationComponent } from './components/message-information/message-information.component';
import { AuthenticationService } from '@app/_services/authentication.service';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { ceil } from 'lodash';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-page-messages',
    templateUrl: './page-messages.component.html',
    styleUrls: ['./page-messages.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, PaginationComponent, DatePipe, TranslateModule]
})
export class PageMessagesComponent implements OnInit {
    user: any;
    params: any = {
        page: 1,
        limit: 30
    }
    constructor(private communicationService: CommunicationsService,
        private modalService: BsModalService,
        private authService: AuthenticationService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) { }
    communications;
    bsModalRef: BsModalRef;
    paginationMessageCount;
    paginationSubject$: Subject<any> = new Subject();
    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.user = user;
            this.params.creatorId = this.user?._id;
        });
        this.communicationService.getAll(this.params).subscribe((response: any) => {
            this.communications = response.data;
            this.paginationMessageCount = ceil(response.messageCount / 30)
        });
        this.paginationSubject$.pipe(
            debounceTime(1000),
            switchMap(() => {
                return this.communications.getAll(this.params);
            })
        ).subscribe((response: any) => {
            this.communications = response.data;
        })
    }

    updateList(pageNumber) {
        this.params.page = pageNumber;
        this.paginationSubject$.next();
    }
    viewMessage(communicationData) {
        const initialState = {
            communicationId: communicationData._id,
            userId: this.user._id,
            companyData: communicationData.companyData
        };
        this.bsModalRef = this.modalService.show(MessageInformationComponent, { initialState, ignoreBackdropClick: true,class: 'modal-lg' });

    }

}
